<template>
  <div
    v-if="props.status == 'approve'"
    class="bg-theme-9 p-2 px-3 rounded-md text-theme-2 inline-block"
  >
    <CheckCircleIcon class="w-4 h-4 mr-2" />{{ props.title }}
  </div>
  <div
    v-else-if="props.status == 'disapprove' || props.status == 'edit_all'"
    class="bg-theme-6 p-2 px-3 rounded-md text-theme-2 inline-block"
  >
    <XCircleIcon class="w-4 h-4 mr-2" />{{ props.title }}
  </div>
  <div v-else class="bg-theme-14 p-2 px-3 rounded-md text-theme-7 inline-block">
    <InfoIcon class="w-4 h-4 mr-2" />{{ props.title }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: String,
    status: String
  },
  setup(props) {
    return {
      props
    }
  }
})
</script>
